// import type { ComponentData } from '@ui/cms/contracts';
// TODO: Create proper separation of UI types
type ComponentData = any; // Temporary fix to avoid UI dependency
import { DeviceType } from '.';

export enum DragItemType {
  Row = 'ROW',
  Component = 'COMPONENT',
}

export enum DropItemType {
  Row = 'ROW',
  Column = 'COLUMN',
}

export type DragItem = {
  id: string;
  type: DragItemType;
  index: number;
};

export type Layout = Pick<LayoutState, 'rootChildren' | 'rows' | 'columns' | 'components'>;

export interface LayoutState {
  rootChildren: string[];
  rows: Record<string, Row>;
  columns: Record<string, Column>;
  components: Record<string, Component>;
  focusedElement: string | null;
  componentSelector: {
    columnId: string;
  } | null;
  editComponentDialog: string | null;
  previewPage: boolean;
  layoutType: DeviceType;
}

export interface Row {
  id: string;
  parentColumnId: string | null;
  columnIds: string[];
}

export enum ColumnAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum ColumnDirection {
  Bottom = 'bottom',
  Right = 'right',
}

export interface Column {
  id: string;
  parentRowId: string;
  size: number;
  childrenIds: string[];
  alignment?: ColumnAlignment;
  direction?: ColumnDirection;
}

export type Component = ComponentData & {
  parentColumnId: string;
};

export type CmsPage = {
  id: string;
  name: string;
  slug: string;
  desktopLayout?: Layout;
  tabletLayout?: Layout;
  mobileLayout?: Layout;
};
